import React, { useState } from 'react';
import OtpInput from 'react-otp-input';
import { useForm, Controller } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useLoginVerifyOTP } from '../Login/api';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Otp = (props) => {
    const location = useLocation()
    const navigate = useNavigate()
    const {t} = useTranslation()

    const schema = Yup.object().shape({
        otp: Yup.string()
            .required(t('OTP is required'))
            .length(6, t('OTP must be exactly 6 digits'))
            .matches(/^\d{6}$/, t('OTP must only contain numbers')),
    });
    const { control, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });
    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false)
    const loginVerify = useLoginVerifyOTP()
    const onSubmit = async (data) => {
        try {
            setLoading(true)
            const loginData = {
                email: location?.state?.email,
                otp: data.otp
            }
            const response = await loginVerify.mutateAsync(loginData)

            if (response.status) {
                sessionStorage.setItem("user_JWT", response?.token)
                navigate('/dashboard')
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }finally{
            setLoading(false)
        }
    };

    return (
        <div className="AuthPg">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-5 col-lg-8">
                        <div className="AuthBgFrm">
                            <h3>{t('OTP')}</h3>
                            <p>{t('Verify Your OTP Code')}</p>
                            <div className='form-group OtpFrmGrp'>
                                <Controller
                                    name="otp"
                                    control={control}
                                    render={({ field }) => (
                                        <OtpInput
                                            {...field}
                                            value={otp}
                                            onChange={(value) => {
                                                setOtp(value);
                                                field.onChange(value);
                                            }}
                                            numInputs={6}
                                            renderSeparator={<span className='mx-1'></span>}
                                            renderInput={(props) => <input {...props} />}
                                        />
                                    )}
                                />
                                {errors.otp && <p className="text-danger">{errors.otp.message}</p>}

                            </div>
                            <div className="form-group">
                                <button className='btn CmnBtn w-100 h-46' onClick={handleSubmit(onSubmit)} disabled={loginVerify.isLoading || loading}
                                >{t('Submit')}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Otp;